import { Component } from '@angular/core';
import { PopoverService } from '@services/popover/popover.service';

@Component({
  selector: 'app-compliance-details-table-popup',
  templateUrl: './compliance-details-table-popup.component.html',
  styleUrls: ['./compliance-details-table-popup.component.scss'],
})
export class ComplianceDetailsTablePopupComponent {

  public title: string;

  constructor(private popoverService: PopoverService) {
  }

  public async close(): Promise<void> {
    await this.popoverService.safeDismiss();
  }

}
